import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyEivPayerMetlifeIcon = lazy(() => import('./svg-components/eiv-payer-metlife-icon'));

const EivPayerMetlifeIcon = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyEivPayerMetlifeIcon {...rest} />
  </Suspense>
);

export default EivPayerMetlifeIcon;
